<template>
  <div class="app-main-content vessel-native">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width:100%" @tab-click="handleClick">
        <el-tab-pane :label="$t('SeaExport.ShippingSchedule')" name="tabShipppingSchedule" :lazy="true">
          <tab-shippping-schedule ref="tabShipppingSchedule" />
        </el-tab-pane>
        <el-tab-pane :label="$t('SeaExport.Voyage')" name="tabVoyage" :lazy="true">
          <tab-voyage ref="tabVoyage" />
        </el-tab-pane>
        <el-tab-pane :label="$t('SeaExport.Vessel')" name="tabVessel" :lazy="true">
          <tab-vessel ref="tabVessel" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import tabShipppingSchedule from './components/tabShipppingSchedule'
import tabVoyage from './components/tabVoyage'
import tabVessel from './components/tabVessel'

export default {
  name: 'Vessel',
  components: { tabShipppingSchedule, tabVoyage, tabVessel },
  data() {
    return {
      activeTabName: 'tabShipppingSchedule'
    }
  },
  methods: {
    // tab 页签点击事件
    handleClick(tab, event) {
      console.log(tab, event)
      if (tab.name === this.activeTabName && this.$refs[this.activeTabName]) {
        this.$refs[this.activeTabName].fetchOrderRequirement()
      }
    }
  }
}
</script>

<style scoped>

</style>
